'use strict';

angular.module('programme')

.component('programmeCategory', {
    controller: 'CategoryCtrl',
    templateUrl: 'modules/programme/components/category.html',
    bindings: {
        model: '<'
    }
})

.controller('CategoryCtrl', function ($scope, $state)
{
    $scope.onClick = function(model)
    {
        $state.go('programme.category', {categorySlug: model.slug});
    };
});
